/**
 * DashboardVersionToggle — opt-in switch between the legacy dashboard and
 * the new Penpot-matched dashboard. Only rendered for the prod-allowlisted
 * tenants (see dashboardVersion.ts).
 */

import * as React from "react";
import Switch from "rc-switch";
import type { DashboardVersion } from "./dashboardVersion";

type Props = {
  value: DashboardVersion;
  onChange: (next: DashboardVersion) => void;
};

export default function DashboardVersionToggle({ value, onChange }: Props) {
  const isNew = value === "new";
  return (
    <div className="px-4 pt-4 flex items-center justify-end gap-2">
      <span className="text-sm text-gray-600">Try the new dashboard</span>
      <Switch
        checked={isNew}
        onChange={(checked: boolean) => onChange(checked ? "new" : "old")}
      />
    </div>
  );
}
